"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Centered = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-async-promise-executor */
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
exports.Centered = react_1["default"].memo(function Centered(props) {
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, __assign({ style: __assign({ display: 'flex', justifyContent: 'center', alignItems: 'center' }, props.style) }, { children: props.children })));
});
